import { Box, keyframes, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { modalColors } from '../../../DiscussionsModal/styled';

const pulse = keyframes`
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
`;

export const DisconnectBanner = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '5px 16px',
    backgroundColor: 'rgba(230, 160, 30, 0.15)',
    borderTop: '1px solid rgba(230, 160, 30, 0.3)',
    fontSize: '12px',
    color: '#e6a01e',
    '& .ws-dot': {
        width: '7px',
        height: '7px',
        borderRadius: '50%',
        backgroundColor: '#e6a01e',
        flexShrink: 0,
        animation: `${pulse} 1.4s ease-in-out infinite`
    }
});

export const SearchBox = styled(Box)({
    padding: '16px'
});

export const SearchField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: modalColors.black5,
        color: modalColors.white,
        fontSize: '14px',
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none'
        },
        '& input': {
            fontSize: '14px'
        },
        '& input::placeholder': {
            color: '#888',
            opacity: 1,
            fontSize: '14px'
        }
    }
});
